import React from 'react';
import './projectCost.css';
import { Outlet } from 'react-router-dom';

const ProjectCost = () => {
  return (
    <div>
      <Outlet></Outlet>
    </div>
  );
};

export default ProjectCost;
